import { openBlock as e, createElementBlock as r, renderSlot as o } from "vue";
import { _ as c } from "./_plugin-vue_export-helper-dad06003.js";
const n = {}, s = { class: "inline-flex items-center ct-bg-2--alt rounded border ct-border-2 px-1 py-0.5 font-sans text-xs ct-text-3" };
function d(t, a) {
  return e(), r("kbd", s, [
    o(t.$slots, "default")
  ]);
}
const f = /* @__PURE__ */ c(n, [["render", d]]);
export {
  f as C
};
